import { de } from '@/translations/locales/de'
import { en } from '@/translations/locales/en'

export const resources = {
  en,
  de,
}
